import { render, staticRenderFns } from "./ProductAddToListButton.vue?vue&type=template&id=d54b537a"
import script from "./ProductAddToListButton.vue?vue&type=script&lang=js"
export * from "./ProductAddToListButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports